module.exports = __webpack_public_path__ + "img/user-account_blue.97413455.svg";